import { Component } from '@angular/core';
import { NzTableData, NzTablePaginationPosition, NzTableSize } from 'ng-zorro-antd/table/src/table.types';

@Component({
	selector: 'app-icon-showcase',
	templateUrl: './icon-showcase.component.html'
})
export class IconShowcaseComponent {
	public icons = [{
		icon: 'save',
		iconName: 'save',
		set: 'feather',
		meaning: 'Speichern',
		description: 'Wird für Buttons benutzt, welche Eingaben speichern sollen.',
	},
	{
		icon: 'edit',
		iconName: 'edit',
		set: 'feather',
		meaning: 'Bearbeiten',
		description: 'Wird für Buttons benutzt, welche zu einem Formular führen um einen Datensatz zu bearbeiten.',
	},
	{
		icon: 'x',
		iconName: 'x',
		set: 'feather',
		meaning: 'Abbrechen / Schließen',
		description: 'Formular schließen und zur oberen Seite in der Hierarchie zurück kehren ohne die Eingaben zu speichern.',
	},
	{
		icon: 'trash',
		iconName: 'trash',
		set: 'feather',
		meaning: 'Löschen',
		description: 'Wird für Buttons benutzt, die einen Datensatz löschen oder zurück setzen sollen.',
	},
	{
		icon: 'chevrons-left',
		iconName: 'chevrons-left',
		set: 'feather',
		meaning: 'Ebene nach Oben',
		description: 'Bewegt sich in der Hierarchy der Seiten um eine Ebene nach Oben. Also zum Beispiel von einer Detailansicht ' +
			'zurück zur Übersicht. Oder von einer Bearbeitung zu der Detailseite',
	},
	{
		icon: 'check',
		iconName: 'check',
		set: 'feather',
		meaning: 'Bestätigen',
		description: 'Bestätigt eine Eingabe und schließt die Bearbeitung ab.',
	},
	{
		icon: 'trello',
		iconName: 'trello',
		set: 'feather',
		meaning: 'Ablenkungsfreier Wizard',
		description: 'Weißt auf die Benutzung des Ablenkungsfreien Wizards hin.',
	},
	{
		icon: 'book-open',
		iconName: 'book-open',
		set: 'feather',
		meaning: 'Kompaktmodus',
		description: 'Weißt auf die Benutzung des Kompaktmodus hin.',
	},
	{
		icon: 'layout',
		iconName: 'layout',
		set: 'feather',
		meaning: 'UI-Showcase',
		description: 'Menü-Icon für das UI-Showcase.',
	},
	{
		icon: 'users',
		iconName: 'users',
		set: 'feather',
		meaning: 'Teilnehmer Verwaltung',
		description: 'Menü-Icon für die Teilnehmerverwaltung.',
	},
	{
		icon: 'database',
		iconName: 'database',
		set: 'feather',
		meaning: 'Projekt',
		description: 'Projektauswahl',
	},
	{
		icon: 'filter',
		iconName: 'filter',
		set: 'NgZorro',
		meaning: 'Filter',
		description: 'Filter Icon für Tabellen. Erlaubt es in Tabellen nach einem Bestimmten Wert zu suchen.',
	}];

	public visibleIcons = this.icons;

	public simple = false;
	public loading = false;
	public pagination = true;
	public position: NzTablePaginationPosition = 'bottom';
	public header = true;
	public title = false;
	public expandable = true;
	public checkbox = false;
	public allChecked = false;
	public footer = false;
	public bordered = false;
	public sizeChanger = false;
	public size: NzTableSize = 'small';
	public privacyMode = false;
	public hasProject = false;

	public iconFilterValue = '';
	public iconNameFilterValue = '';
	public setFilterValue = '';
	public meaningFilterValue = '';
	public descriptionFilterValue = '';

	public iconFilterVisible = false;
	public iconNameFilterVisible = false;
	public setFilterVisible = false;
	public meaningFilterVisible = false;
	public descriptionFilterVisible = false;

	compareIcon(a: NzTableData, b: NzTableData): number {
		return a.icon.localeCompare(b.icon);
	}

	compareIconName(a: NzTableData, b: NzTableData): number {
		return a.iconName.localeCompare(b.iconName);
	}

	compareSet(a: NzTableData, b: NzTableData): number {
		return a.set.localeCompare(b.set);
	}

	compareMeaning(a: NzTableData, b: NzTableData): number {
		return a.meaning.localeCompare(b.meaning);
	}

	compareDescription(a: NzTableData, b: NzTableData): number {
		return a.description.localeCompare(b.description);
	}

	filterIcon(): void {
		this.resetFilters('icon');
		this.visibleIcons = this.icons.filter(item =>
			item.icon.toLowerCase().includes(this.iconFilterValue.toLowerCase()));
	}

	filterIconName(): void {
		this.resetFilters('iconName');
		this.visibleIcons = this.icons.filter(item =>
			item.iconName.toLowerCase().includes(this.iconNameFilterValue.toLowerCase()));
	}

	filterSet(): void {
		this.resetFilters('set');
		this.visibleIcons = this.icons.filter(item =>
			item.set.toLowerCase().includes(this.setFilterValue.toLowerCase()));
	}

	filterMeaning(): void {
		this.resetFilters('meaning');
		this.visibleIcons = this.icons.filter(item =>
			item.meaning.toLowerCase().includes(this.meaningFilterValue.toLowerCase()));
	}

	filterDescription(): void {
		this.resetFilters('description');
		this.visibleIcons = this.icons.filter(item =>
			item.description.toLowerCase().includes(this.descriptionFilterValue.toLowerCase()));
	}

	private resetFilters(filterName: string): void {
		switch (filterName) {
			case 'icon':        this.iconFilterValue = '';        return;
			case 'iconName':    this.iconNameFilterValue = '';    return;
			case 'set':         this.setFilterValue = '';         return;
			case 'meaning':     this.meaningFilterValue = '';     return;
			case 'description': this.descriptionFilterValue = ''; return;
		}
	}
}
